import { useEffect, useRef } from 'react'
import { Cloud, Code2, GitPullRequest, Terminal, Boxes, Activity, ShieldCheck, Container, Network, FileCode2, Languages, type LucideIcon } from 'lucide-react'
import { SKILL_CATEGORIES } from '../data/skills'
import { setupPanelReveals } from '../lib/motion'

const ICONS: LucideIcon[] = [
  Cloud,
  Code2,
  GitPullRequest,
  Terminal,
  Boxes,
  Activity,
  ShieldCheck,
  Container,
  Network,
  FileCode2,
  Languages,
]

const SkillsGrid: React.FC = () => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const node = ref.current
    if (!node) return
    return setupPanelReveals(node, { drawLine: true })
  }, [])

  return (
    <div ref={ref} className="grid gap-5 sm:grid-cols-2" data-reveal-item-parent>
      {SKILL_CATEGORIES.map((category, i) => {
        const Icon = ICONS[i % ICONS.length]
        return (
          <div
            key={category.title}
            data-reveal-item
            className="group relative rounded-xl border border-neutral-200/70 bg-white/60 p-6 backdrop-blur-sm transition-colors duration-300 hover:border-primary-300/50 dark:border-white/8 dark:bg-white/[0.03] dark:hover:border-primary-400/30"
          >
            <div className="flex items-start justify-between gap-3">
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-500/10 text-primary-500">
                  <Icon size={18} />
                </span>
                <h3 className="font-display text-sm font-semibold tracking-tight">{category.title}</h3>
              </div>
              <span className="font-mono text-[11px] text-neutral-400 dark:text-neutral-500">
                {String(i + 1).padStart(2, '0')}
              </span>
            </div>

            <p className="mt-4 text-sm leading-relaxed text-neutral-600 dark:text-neutral-300">
              {category.description}
            </p>

            <ul className="mt-4 flex flex-wrap gap-2">
              {category.skills.map((skill) => (
                <li
                  key={skill}
                  className="inline-flex items-center rounded-md border border-neutral-200 dark:border-white/8 px-2.5 py-1 font-mono text-xs text-neutral-500 dark:text-neutral-400"
                >
                  {skill}
                </li>
              ))}
            </ul>
          </div>
        )
      })}
    </div>
  )
}

export default SkillsGrid
